import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SidebarNav } from './SidebarNav';
import { Topbar } from './Topbar';
import { useCurrency } from '@/context/CurrencyContext';
import { trackPageView } from '@/lib/analytics';

export const AppShell = ({ title }) => {
  const { currency, ready } = useCurrency();
  const location = useLocation();
  // Log a page view whenever the route changes (engagement analytics).
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);
  return (
    <div className="min-h-screen bg-[#F6F7F9]">
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 flex-col z-40 shadow-[1px_0_0_rgba(13,21,38,0.04)]">
        <SidebarNav />
      </aside>
      <div className="lg:pl-64">
        <Topbar title={title} />
        <main key={`${currency}:${ready}`} className="px-4 sm:px-6 lg:px-8 py-6 max-w-[1560px] animate-fade-in">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
